import { Component, OnDestroy } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { HeaderService } from "src/app/components/header/header.service";

@Component({
  selector: "app-seller-id-with-hyperlink-cell-renderer",
  templateUrl: "./seller-id-with-hyperlink-cell-renderer.component.html",
  styleUrls: ["./seller-id-with-hyperlink-cell-renderer.component.scss"],
})
export class SellerIdWithHyperlinkCellRendererComponent implements OnDestroy {
  params: any;
  selectedAccountType: string;
  private destroy$ = new Subject<void>();

  constructor(private headerService: HeaderService) {
    this.headerService.accountSelectedType.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.selectedAccountType = e[0].toLocaleLowerCase();
    });
  }

  agInit(params: any): void {
    this.params = params;
  }

  stopPropagation(e) {
    e.stopPropagation();
  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
